// Remembers an account that still needs email verification, so the user can
// come back later (reload, close the verify modal, close the tab) and finish
// it — the backend's verify endpoint needs the user_id up front and has no
// email-only lookup, so without this the user_id from the signup response
// would otherwise be lost the moment the modal closes.
const KEY = "im_pending_verification";

export const savePendingVerification = (userId, email) => {
    try {
        localStorage.setItem(KEY, JSON.stringify({ userId, email }));
    } catch (e) { /* storage unavailable — verification still works this session */ }
};

export const getPendingVerification = () => {
    try {
        const raw = localStorage.getItem(KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
};

export const clearPendingVerification = () => {
    try {
        localStorage.removeItem(KEY);
    } catch (e) { /* nothing to clear */ }
};
